<!--镜片类：采购岗发起采购页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>

      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td width="120" style="padding-bottom: 10px">
            <el-radio-group v-model="isBackorder" size="mini" :fill="isBackorder?'#F56C6C':'#67C23A'">
            <el-radio-button :label="false">采购单</el-radio-button>
            <el-radio-button :label="true" >退货单</el-radio-button>
          </el-radio-group>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="120">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">产&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td width="220">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="550"
                        :treeHeight="500" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
          <td width="60">
            <el-button type="warning" @click="initnum" size="mini" v-if="intelligentstore&&!isBackorder"  plain>一键补货</el-button>
          </td>
          <td width="140">
            {{form.seedcode}}
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">供应商：</td>
          <td width="140">
            <el-select v-model="controlData.pcustomerserial" placeholder="请选择" filterable size="mini" @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
          <td colspan="2"><el-button type="warning" @click="loadfromorder" size="mini" v-if="controlData.pcustomerserial" plain >从采购单导入</el-button></td>
        </tr>
        <tr class="noborder">
          <td align="right"  v-if="!ssotoken">供应号：</td>
          <td width="140"  v-if="!ssotoken">
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号" onfocus="this.select()"></el-input>
          </td>
          <!--<td align="right">跟踪号：</td>-->
          <!--<td width="140">-->
            <!--<el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号" onfocus="this.select()"></el-input>-->
          <!--</td>-->
          <td></td>
          <td></td>
        </tr>
        <tr class="noborder" v-show="showerweitable">
          <td colspan="6">
            <TwoDimensionalTable ref="referweibiao" :cutHeight="311" :erweitable="erweitable" :usermax="usermax" :enablenegative="true"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoright" :cutHeight="311" :erweitable="erweitableright" :usermax="usermax" :enablenegative="true"></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoleft" :cutHeight="311" :erweitable="erweitableleft" :usermax="usermax" :enablenegative="true"></TwoDimensionalTable>
            </el-col>
          </td>
        </tr>
        <tr class="noborder" v-show="showNumberSelect">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">数量：</el-col>
            <el-col :span="4">
              <el-input v-model="totalnumber" auto-complete="off" :required="true" style="width: 200px"></el-input>
            </el-col>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 60px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button type="warning" plain size="mini" v-if="!isBackorder&&ssotoken" @click="saveDataNotoken" style="float: left">确认采购（线下联系供应商下单）</el-button>
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData">{{isBackorder?'生成退货单':'生成采购单'}}</el-button>
      <el-button type="warning" @click="importEdit" size="mini" v-if="form.seedname">二维表导入</el-button>
      <a href="./static/file/镜片导入格式.xls">下载模板</a>
      <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
    </div>
    <BuyorderDetail ref="BuyorderDetail"></BuyorderDetail>
    <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
    <ewmPay ref="ewmPay1" @UnionPay="afterUnionPay" :ewmpre="'buyorderdetailedit'" @CancelUnionPay="afterCancelUnionPay"></ewmPay>
    <StoreDetailListSupplySee ref="OrderSupplySee1" :showcostprice="false" :allowSelect="true" @afterSelect="afterSelectOrder"></StoreDetailListSupplySee>
  </el-dialog>
</template>


<script>
  import {buyorderdetaillist,SSOrelatedOrder} from '@/api/set/csagreement';
  import BuyfromSupplyer from '../buyagreement/BuyfromSupplyer';
  import {login, createOrder,backOrder} from '@/api/ossi';
  import {suppliers} from '@/api/set/externaldept';
  import ewmPay from './ewmPay';
  import {getRemark} from '@/plugin/ordercommon'
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import BuyorderDetail from '../buyagreement/BuyorderDetail';
  import {getGoodsNeedBuy, getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {checkModuleRight} from '@/api/login'
  import StoreDetailListSupplySee from '../../account/StoreDetailListSupplySee'
  import {isUGO} from '@/api/login';

  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersavedetail, jxcstorelist, getpcustomerserial
  } from '@/api/set/csagreement';

  import {getDetail} from '@/api/set/jxcgooddetail'
  import {getListData} from '@/api/set/jxcstore'
  import {cusandptbyind} from '@/api/set/jxcstore';

  export default {
    name: 'BuyorderDetailEdit',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        ssotoken: "",
        ssobuyerpserial:"",
        website: "",
        ssoT:false,
        userInfoModel: {},
        book: {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []},
        erweitable: [],//二维表
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        storeinfo: [],//库存信息
        storeinforight: [],//右库存信息
        storeinfoleft: [],//左库存信息
        intelligentstore: false,
        costpricebook: {},
        dialogFormVisible: false,
        title: "",
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        remark: '',
        UGO:false,
        cangkucode: '',
        cangkuname: '',
        tableData: [
          {column: []},
        ],
        unitguid: "",
        column: [],
        ptableData: [],
        pcustomerserial:'',
        controlData: {
          pcustomerserial:'',
          pcustomer:'',
          cangkuname:'',
          cangkucode:'',
          remark:''
        },
        storenumtable: [],
        showtitle1: "none",
        jxcstoreData: [],
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        showNumberSelect: false,//数量选择
        totalnumber: '',
        isBackorder: false,
        usermax:false,
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
      }
    },
    methods: {
//绑定库存
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        this.storeinfoleft = [];
        this.storeinforight = [];
        this.storeinfo = [];
        this.usermax = false;

        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          cangkucode: this.controlData.cangkucode,
          calculateStore: "1"
        }).then(resStore => {
          if (resStore.data.obj.length > 0) {
            resStore.data.obj.forEach(o => {
              if (o.packagesize) {
                let ob = JSON.parse(o.packagesize)
                ob.P = o.subtractnum - o.deliverying;// + o.transfernum;
                ob.maxstore = o.setmaxstore;
                if (o.setmaxstore>0)//存在最大库存
                  this.usermax = true;
                if (ob.type == 'L') {
                  this.storeinfoleft.push(ob);
                } else if (ob.type == "R") {
                  this.storeinforight.push(ob);
                } else {
                  this.storeinfo.push(ob);
                }
              }
            })
          } else {

          }
          this.createPriceBook()
        }).catch((error) => {
          console.log(error)
        });
      },
      //导入二维表
      importEdit() {
        this.loadbylist=false;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            console.log(data);
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let obj = {}
              if(this.loadbylist) {
                data.forEach((item) => {
                  var pg = JSON.parse(item['光度']);
                  pg.P = Math.abs(parseInt(item['数量']));
                  arr.push(pg)
                })
              }else {
                data.forEach((item) => {
                  let Y = ""
                  for (let X in item) {
                    obj = {}
                    if (X == "球\\柱") {
                      Y = parseFloat(item[X]).toFixed(2)
                    } else {
                      if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                        obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": Math.abs(parseInt(item[X]))}
                        if (this.type) {
                          obj.type = this.type
                        }
                        arr.push(obj)
                      }
                    }
                  }
                })
              }
            }
            this.BookContent = arr
            this.createPriceBook()
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      getTitle() {
        let result = (this.userInfoModel.independentserial?this.userInfoModel.independentfdname:this.userInfoModel.tenantname)
        result += "采购订单"
        return result
      },
      loadfromorder() {//选择采购单
        var end = new Date();//当天
        var year = end.getFullYear();
        var month = end.getMonth() + 1;
        var searchdatevalue = [(month > 6 ? (year + '-' + (month - 6)) : ((year - 1) + '-' + (6 + month))) + '-' + end.getDate(),
          year + '-' + month + '-' + end.getDate()];
        this.$refs.OrderSupplySee1.initData({
          applybydserial: this.controlData.pcustomerserial,
          applybydname: this.controlData.pcustomer,
          otherparam:{
            searchstatus:'1',
            seedcode:this.form.seedcode,
            seedname:this.form.seedname,
          }
        }, 3, searchdatevalue, "");
        this.$refs.OrderSupplySee1.show();
      },
      afterSelectOrder(orderDetail) {
        var arr = [];
        for (let i in orderDetail.goodsDetail[0].billmap) {
          var row = orderDetail.goodsDetail[0].billmap[i];
          if(!row.seedcode) continue;
          if(!row.packagesize||!row.packagesize.indexOf('X')==-1) {
            this.$message.error("请选择镜片类订单！")
            return;
          }
          var pg=JSON.parse(row.packagesize);
          pg.P=Math.abs(row["数量"]);
          arr.push(pg);
        }
        if(arr.length>0) {
          this.BookContent = arr
          this.createPriceBook()
        }
      },
      initnum() {
        if (this.form.seedcode && this.intelligentstore) {
          getGoodsNeedBuy({seedcode: this.form.seedcode, cangkucode: this.controlData.cangkucode}).then(response => {
            for (let i in response.data.obj) {
              let packagesize = JSON.parse(response.data.obj[i]["packagesize"])
              packagesize["P"] = response.data.obj[i]["maxstore"]
              if (this.showzuoyoutable) {//左右眼
                if (packagesize["type"] == "L") {
                  this.BookContentLeft.push(packagesize)
                } else {
                  this.BookContentRight.push(packagesize)
                }
              } else if (this.showerweitable) {
                this.BookContent.push(packagesize)
              } else if (this.showNumberSelect) {

              }
            }
            if (!this.showNumberSelect)
              this.getXYRange()
          }).catch((error) => {
            console.log(error)
          });
        } else {
          this.$message({
            message: '请选择货品',
            type: 'info'
          })
        }
      },
      changepcu(val) {
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == this.controlData.pcustomerserial) {
            this.controlData.pcustomer = this.ptableData[i].deptname
          }
        }
        if (val) {
          this.getXYRange(true)
        }
      },
      checktree1(guids, names, arr) {
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.filltemplate = arr[0].attributes.filltemplate
        this.costpricebook = {}
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.filltemplate == '30') {//显示左右眼table
          this.showzuoyoutable = true
          this.showerweitable = false
          this.showNumberSelect = false
        } else if (this.filltemplate == '10' || this.filltemplate == '20') {//显示现片定制片下单
          this.showzuoyoutable = false
          this.showerweitable = true
          this.showNumberSelect = false
        } else if (this.filltemplate == '40') {
          this.showzuoyoutable = false
          this.showerweitable = false
          this.showNumberSelect = true
        }

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }

        this.geterweibiao()
      },

      //判断是否有供应商
      geterweibiao() {
        suppliers({seedcodes: '["' + this.form.seedcode + '"]', search: ""}).then((response) => {
          this.ptableData = response.data.obj
          if (this.ptableData.length > 0) {
            this.controlData.pcustomerserial = this.ptableData[0].customerserial
            this.controlData.pcustomer = this.ptableData[0].deptname
            // this.controlData.clinkman = this.ptableData[0].linkman
            // this.controlData.clinkmantel = this.ptableData[0].linkmantel
            // this.controlData.caddress = this.ptableData[0].address
            this.getXYRange()
          }
        })
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,categorystarts:'001;010',filltemplates:'10;30'})
        })
      },
      getXYRange(changecangku) {
        this.ssotoken="";
        if (!this.controlData.pcustomerserial)
          return;

        //根据供应商取价格范围
        getPrice({
          seedcode: this.form.seedcode,
          customerSerial: this.controlData.pcustomerserial,
          filterType: 'cost'
        }).then((response) => {
          if(!changecangku) {
            if (response.data.code == 0 && response.data.obj) {
              this.costpricebook = response.data.obj
            } else {
              this.costpricebook = {}
            }
          }
          if(response.data.obj.dept.usesso==1&&response.data.obj.dept.ssocode){
            login({idencode: response.data.obj.dept.ssocode, tenantid: this.userInfoModel.tenantid, independentserial: this.userInfoModel.independentserial}).then(loginres => {
              if (loginres.data.code == 0) {
                this.ssotoken = loginres.data.msg;
                this.website=loginres.data.website;
              } else {
                this.$message({message: loginres.data.msg,type: 'error'})
              }
            });
          }

          //绑定库存
          if(!changecangku) {
            this.bindStore()
          }
        })
      },
      createPriceBook() {
        if (this.filltemplate == 30) {
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft, '', this.storeinfoleft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight, '', this.storeinforight)
        } else {
          this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent, '', this.storeinfo)
        }
      },

      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)

          this.showtitle1 = "none"
        })
      },
      show() {
        this.ssobuyerpserial="";
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
        this.BookContent = []
        if (this.form.seedcode) {
          this.bindStore()
        }
        // this.createPriceBook()
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },

      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      saveDataNotoken(){
        this.saveData('notoken');
      },
      saveData(notoken) {
        //取出对应的表单详情和数量
        var arr = [];
        if (this.showzuoyoutable) {//左右眼
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {
              t.type = "L"
              return typeof(t.P) != "undefined" && t.P !== "" && t.P !== "0";
            })
            arr = arr.concat(temp)
          }
          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              t.type = "R"
              return typeof(t.P) != "undefined" && t.P !== "" && t.P !== "0";
            })
            arr = arr.concat(temp)
          }
        }
        else if (this.showerweitable) {//非左右眼
          for (let i in   this.erweitable) {
            let temp = this.erweitable[i].filter((t) => {
              return typeof(t.P) != "undefined" && t.P !== "" && t.P !== "0";
            })
            arr = arr.concat(temp)
          }
        } else {
          if (parseInt(this.totalnumber)) {
            arr.push(
              {
                P: this.totalnumber
              }
            )
          } else {
            this.$message({
              message: '请输入需要采购的数量！',
              type: 'warning'
            })
            return
          }
        }
        if (arr.length == 0) {
          this.$message({
            message: '请输入需要采购的数量！',
            type: 'warning'
          })
          return
        }

        if (this.isBackorder) {
          for (let i in arr) {//全部转换成负数
            arr[i].P = -Math.abs(arr[i].P);
          }
        }

        if (!this.controlData.pcustomerserial) {
          this.$message({
            message: '请选择供应商！',
            type: 'warning'
          })
          return
        }
        if (!this.controlData.cangkucode) {
          this.$message({
            message: '请选择仓库！',
            type: 'warning'
          })
          return
        }
        this.ssoT=true;
        var ssoTok=this.ssotoken;
        if(notoken&&notoken=='notoken') {
          ssoTok = "";
          this.ssoT = false;
        }

        if (ssoTok && !this.isBackorder) {//需要向供应商发起采购 (退货单不发起)
          var ckInfo = {};
          for (let i in this.jxcstoreData) {
            if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
              ckInfo = this.jxcstoreData[i];
            }
          }
          var buyForms = '['
          for (let j in arr) {
            if (buyForms != '[')
              buyForms += ',';
            buyForms += '{"seedcode":"' + this.form.seedcode + '",'
            if (arr[j].type)
              buyForms += '"type":"' + arr[j].type + '",'
            if (arr[j].X || arr[j].X == 0)
              buyForms += '"X":"' + parseFloat(arr[j].X).toFixed(2) + '",'
            if (arr[j].Y || arr[j].Y == 0)
              buyForms += '"Y":"' + parseFloat(arr[j].Y).toFixed(2) + '",'
            buyForms += '"Number":' + arr[j].P + '}'
          }
          buyForms += ']';
          var remarkStr = '[]';
          if (this.controlData.remark) {
            remarkStr = '[{"msg":"' + this.controlData.remark + '","date":"' + this.CurentTime() + '","uname":"备注","type":"客户留言"}]';
          }
          createOrder({
            cangkucode:this.controlData.cangkucode,
            uname: this.userInfoModel.uname,
            uguid: this.userInfoModel.uguid,
            linkman: ckInfo.applyby,
            linkmantel: ckInfo.tel,
            deliverymode: '配送',
            deliveryaddress: ckInfo.adressdetail,
            formproperty: buyForms,
            remark: remarkStr,
            ssobuyerpserial:this.ssobuyerpserial,
          }, this.ssotoken).then(response => {
            var OrderData = response.data;
            if (OrderData.price) {
              var priceList = OrderData.price;//{商品编码:价格} 只有一个商品
              for (let j in arr) {
                arr[j].gysprice = priceList[this.form.seedcode]
              }
            }
            if(OrderData.ssobuyerpserial){
              this.ssobuyerpserial=OrderData.ssobuyerpserial;
            }
            this.tracknum = OrderData.erpserial;
            if (OrderData.code == 0) {
              this.postBuyData(arr, '上游订单已生成，供应商单号：' + this.tracknum);
            } else {
              if (OrderData.groupguid) {//打开支付页面
                if (!response.data.paytype == 'unionpay') {
                  this.$message({message: '尚未开通支付通道！', type: 'error'});
                  return;
                }
                OrderData.postdata = arr;
                this.$refs.ewmPay1.show(OrderData, this.ssotoken);
              } else {
                this.$message({
                  message: response.data.msg ? response.data.msg : '提交的商品不存在！',
                  type: 'error'
                })
                this.loading = false
              }
            }
          });
        } else {
          this.ssobuyerpserial="";
          this.postBuyData(arr, '保存成功！');
        }
      },
      postBuyData(arr,msg) {
        buyodersavedetail({
          jxcforms: JSON.stringify(arr),
          map: JSON.stringify({
            pcustomerserial: this.controlData.pcustomerserial,
            pcustomer: this.controlData.pcustomer,
            cangkuname: this.controlData.cangkuname,
            cangkucode: this.controlData.cangkucode,
            address: '',
            linkman: '',
            linkmantel: '',
            ssobuyerpserial:this.ssobuyerpserial,
            seedcode: this.form.seedcode,
            seedname: this.form.seedname,
            seedinfo: this.form.seedinfo,
            remark: this.controlData.remark?this.controlData.remark:'',
            tracknum: this.tracknum.trim(),//供应商单号
            logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
            invoicesource: 0,//待审核
            status: 810,
          })
        }).then(response => {
          this.ssobuyerpserial="";
          if (response.data.code == 0) {
            if (this.ssotoken&&this.ssoT) {
              if (this.ssotoken.split('?')[0] == 'http://thisapi') {

              } else {
                SSOrelatedOrder({
                  erpserial: this.tracknum.trim(),
                  parenterpserial: response.data.obj.erpserial,
                  uname: '客户采购单号',
                  customername: this.controlData.cangkuname.replace('仓库', '')
                }, this.ssotoken).then(response => {
                })
              }
            }

            this.$message({
              message: msg,
              type: 'success'
            })
            this.$emit('bindGrid');
            //this.lookbuyorderdetail(response.data.obj, 1)
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
          this.dialogSeeVisible = false;
          //刷新列表
        });
      },
      afterUnionPay(row){
        this.postBuyData(row.postdata, '支付成功！上游订单已生成，供应商单号：' + this.tracknum + '');
      },
      afterCancelUnionPay(row){//撤销支付
        backOrder({erpserial: row.erpserial}, this.ssotoken).then(resDel => {
          this.loading = false;
        });
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, isbuyorder)
        this.$refs.BuyorderDetail.show();
      },
      CurentTime()
      {
        var now = new Date();

        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分

        var clock = year + "-";

        if(month < 10)
          clock += "0";

        clock += month + "-";

        if(day < 10)
          clock += "0";

        clock += day + " ";

        if(hh < 10)
          clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        return(clock);
      },
      initData(row) {
        this.initForm();
        this.ptableData = [];
        if (row == null)
          return;
        //buyorderdetaillist({}).then(response => {
        //   this.controlData = response.data.obj.detail;
        //   this.tableData = response.data.obj.goodsDetail;
        this.controlData.cangkucode = row.cangkucode;
        this.controlData.cangkuname = row.cangkuname;

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.costpricebook = ""
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
          this.form.seedinfo = ""
          this.book = {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []}
          this.erweitable = []
        }
        this.index = -99
        this.addvisible = true
        this.form.seedcode = ''
        this.form.seedname = ''
        if (row) {
          getDetail({seedcode: row.seedcode}).then(response => {
            this.filltemplate = response.data.obj.filltemplate
            this.form.seedcode = response.data.obj.seedcode
            this.form.seedname = response.data.obj.seedname
            if (this.filltemplate == '30') {//显示左右眼table
              this.showzuoyoutable = true
              this.showerweitable = false
              this.showNumberSelect = false
            } else if (this.filltemplate == '10' || this.filltemplate == '20') {//显示现片定制片下单
              this.showzuoyoutable = false
              this.showerweitable = true
              this.showNumberSelect = false
            } else if (this.filltemplate == '40') {
              this.showzuoyoutable = false
              this.showerweitable = false
              this.showNumberSelect = true
            }
            this.geterweibiao()
            this.initnum()
          })
        }
        // });
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.ssobuyerpserial="";
        this.isBackorder=false;
        this.form.seedname='';
        this.groupguid = ""
        this.column = []
        this.ssotoken=""
        this.tableData = []
        this.unitguid = ""
        this.BookContent = []
        this.BookContentLeft = []
        this.controlData.pcustomerserial = ''
        this.controlData.pcustomer =''
        this.BookContentRight = []
        this.showzuoyoutable = false
        this.showerweitable = false
        this.showNumberSelect = false
        this.filltemplate = ""
        this.totalnumber = '';
        this.tracknum = ''
        this.logisticstracknum = ''
        this.controlData.remark='';
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
      }
    },
    mounted() {
      this.UGO=isUGO();
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel=JSON.parse(temp);
      }

      checkModuleRight({name: 'intelligentstore'}).then(reponse => {
        this.intelligentstore = reponse.data.code == 0;
      });

      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        this.controlData.cangkucode = this.jxcstoreData[0].cangkucode;
        this.changename(this.controlData.cangkucode);
      })
    },

    components: {
      TwoDimensionalTable,
      BuyorderDetail,
      BuyfromSupplyer,
      StoreDetailListSupplySee,
      ewmPay
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyorderDetailEdit.vue